import { Component, OnInit, ViewChild } from '@angular/core';
import {DateService} from '../services/date.service'
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MatSelectionList } from '@angular/material/list';
import { EditorComponent } from "../editor/editor.component";
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
  selector: 'app-avt-evenement',
  templateUrl: './avt-evenement.component.html',
  styleUrls: ['./avt-evenement.component.scss']
})
export class AvtEvenementComponent implements OnInit 
{

  constructor( public router:Router,public generalService:GeneralService, public route: ActivatedRoute,public dateService :DateService) { }
  // ds evennement
  evenement;
  
  // code evemment pour le mode modifier
  param_code : string;
  
  // mode : 1 ajouter, 2 modifier, 3 consulter
  typeTrs : string;

  // pour afficher ou masquer la barre de chargement
  exist : boolean = true;
  
  // pour desactiver les input type="text" on k de mode consulter 
  disabled : boolean = false;

  // liste des Selection choisie de TypesPublic
  listeSelectionTypesPublic = []

  // liste des Selection choisie de TypesDiffusion
  listeSelectionTypesDiffusion = []
  typesPublic=[]
  diffusions =this.generalService.sort(this.generalService.diffusions,"text")  
  listePositionEvennement =this.generalService.listePositionEvennement;
  // ds evennement en totaliter
  dsEvenement;

  // liste time pour le coposons autocomplete
  filterdTime = [];
  
  // liste time ex: 7:00, 7:15, 7:30....
  time = [];
  
  // il contient les parametre de temps viennent le serveur
  paramHeure
  //ne pas supprimer la valeur par défault
  // positionEvennement: string = "4";
  // showPositionEvennement : boolean = false;
  @ViewChild("editor" , {static: false}) editor : EditorComponent
  @ViewChild("ev_Type_diffusion",{static : false}) ev_Type_diffusion : MatSelectionList
  @ViewChild("ev_Type_public",{static : false}) ev_Type_public : MatSelectionList;
  avatarSrc : string = "../../assets/image.png";
  imageName : string;
  imageType : string;
  imageSrc: string;
  saveImageFinishe = false;
  deleteFinish = false;
  // Angular Editor Supprimer
  // editorConfig: AngularEditorConfig = JSON.parse(JSON.stringify(this.generalService.editorConfig)) ;

  ngOnInit()
  {
    this.evenement = {};
    this.getParamHeur();
    this.readParamUrl();
  }
  getImage()
  {
    if(this.typeTrs != "1")
      this.generalService.rechercheTable(this.generalService.urlFindDoc+this.param_code+","+"evenementImage"+","+"evenementImage").subscribe(data =>
      {      
        if( data.length>0)
        {
          this.avatarSrc = data[data.length-1].File_Autre + data[data.length-1].File_Content;
        }
      })
    else
    {
      this.avatarSrc = "../../assets/image.png";
      this.imageName =""
      this.imageType =""
      this.imageSrc =""
    }
  }
  getListeMenu()
  {
    this.generalService.rechercheTable("recherche/tbdata?tablere=menu").subscribe(data => 
    {
      this.typesPublic = data;
      this.exist = true;
      setTimeout(()=>
      {
        this.genererEv_Type_publicEtEv_Type_diffusion()
      },100)
    });
  }
  genererEv_Type_publicEtEv_Type_diffusion()
  {
    if(this.typeTrs != "1")
    {
      this.dsEvenement.avtEvenementDest.forEach(element => 
      {
        var opt = this.ev_Type_public.options.find(option =>{return option.value == element.TypeDestination_Code})
        if(opt)
          opt.selected = true
      });
      this.dsEvenement.avtEvenementDiff.forEach(element => 
      {
        // if(element.TypeDiffusion_Code == "4" || element.TypeDiffusion_Code == "5" || element.TypeDiffusion_Code == "6")
        // {
        //   this.showPositionEvennement = true;
        //   this.positionEvennement = element.TypeDiffusion_Code
        // }
        // else
        // {
          var opt = this.ev_Type_diffusion.options.find(option =>{return option.value == element.TypeDiffusion_Code})
          if(opt)
            opt.selected = true
        // }
        
      });
      // setTimeout(()=>
      // {
      //   this.showOrHidePositionEvennement();
      // },50)      
    }
    else
    {
      this.deSelectAll2()
      this.deSelectAll()
    }
  }
  selectImage()
  {
    document.getElementById('imageFile').click();
  } 
  onChangeImagefile(fileInput)
  {         
    var reader2 = new FileReader();
    var src : string; 
    reader2.onload = (e) =>
    {
      src = reader2.result.toString();
      this.avatarSrc = src;
      this.imageName = fileInput.target.files[0].name;      
      this.imageType = src.substring(0,src.indexOf(",")+1);
      this.imageSrc=  src.replace(this.imageType,"");
      // if(this.typeTrs =="2")
      // {
      //   this.exist = false;
      //   this.saveImage(this.param_code);
      // }
    }
    reader2.readAsDataURL(fileInput.target.files[0]);    
  }
  
  // aller au fenettre liste evennement
  retourListes()
  {
    var windows = this.generalService.popupCenter("/w/avt/liste/evenement");
    windows.onbeforeunload = ()=>
    {
      
    }  
    // this.generalService.ajouterScroll = true;
    // this.generalService.dialogOpend = this.generalService.dialog.open(AvtListeEvennementComponent, new MatDialogConfig());
    // this.generalService.dialogOpend.afterClosed().subscribe(() =>
    // {
    //   this.generalService.ajouterScroll = false;
    // });
  }
  genererListeDefEtListePublicToDelete()
  {
    this.generalService.rechercheTable("ds/formdata?code=avtEvenement&val="+this.param_code).subscribe(dsEvenement => 
    {
      this.dsEvenement = dsEvenement;
      var compteDest = 0
      var compteDiff = 0
      var deleteEvenementDestFinish = false
      var deleteEvenementDiffFinish = false;
      if( dsEvenement.avtEvenementDest.length ==0)
        deleteEvenementDestFinish = true;
      dsEvenement.avtEvenementDest.filter(des =>{return this.generalService.isNotEmpty(des.id)}).forEach(dest =>
      {
        if(this.ev_Type_public.selectedOptions.selected.find(option => {return option.value == dest.TypeDestination_Code}) == undefined)
        {
          compteDest++;
          this.generalService.supprimerSanMsgConfirm(dest.id,"avtEvenementDest").subscribe(()=>
          {
            compteDest--
            if(compteDest == 0)
            {
              deleteEvenementDestFinish = true;
              if(deleteEvenementDiffFinish)
              {
                this.deleteFinish = true;
                this.tryHideLoading();
              }
                
            }
          })
        }
      });
      if(compteDest == 0)
        deleteEvenementDestFinish = true;
      if(dsEvenement.avtEvenementDiff.length == 0)
      deleteEvenementDiffFinish = true;
      var liste = JSON.parse(JSON.stringify(dsEvenement.avtEvenementDiff.filter(diff =>{return this.generalService.isNotEmpty(diff.id)}))) ;
      // var evDif = this.dsEvenement.avtEvenementDiff.find(element => {return element.TypeDiffusion_Code == "3"});
      liste.forEach(option =>
      {
        if(this.ev_Type_diffusion.selectedOptions.selected.find(dest => {return dest.value == option.TypeDiffusion_Code}) == undefined)
        {
          var condition = true;
          // if(evDif)
          //   condition = option.TypeDiffusion_Code != this.positionEvennement
          if(condition)
          {
            compteDiff++
            this.generalService.supprimerSanMsgConfirm(option.id,"avtEvenementDiff").subscribe(()=>
            {
              compteDiff--
              if(compteDiff == 0)
              {
                deleteEvenementDiffFinish = true;
                if(deleteEvenementDestFinish)
                {
                  this.deleteFinish = true;
                  this.tryHideLoading();
                } 
              }
            })            
          }
          
        }
      })
      if(compteDiff == 0)
            deleteEvenementDiffFinish = true;
      if(deleteEvenementDestFinish && deleteEvenementDiffFinish)
      {
        this.deleteFinish = true
        this.tryHideLoading();
      }
    });
  }
  genererListeDefEtListePublicToAdd(dsEvenement)
  {
    this.ev_Type_public.selectedOptions.selected.forEach(dest =>
    {
      if(dsEvenement.avtEvenementDest.find(option => {return option.TypeDestination_Code == dest.value}) == undefined)
      {
        var des;
        if(this.typeTrs == "2")
        {
          des =
          {
            Evenement_Code: this.param_code,
            TypeDestination_Code: dest.value,
            U_timestamp: null
          }          
        }
        else
        {
          des =
          {
            TypeDestination_Code: dest.value,
            U_timestamp: null
          }          
        }
        dsEvenement.avtEvenementDest.push(JSON.parse(JSON.stringify(des)))
      }
    });
    dsEvenement.avtEvenementDest = dsEvenement.avtEvenementDest.filter(des =>{return this.generalService.isNotEmpty(des.Evenement_Code)})
    this.ev_Type_diffusion.selectedOptions.selected.forEach(option =>
    {
      if(dsEvenement.avtEvenementDiff.find(diff => {return diff.TypeDiffusion_Code == option.value}) == undefined)
      {
        dsEvenement.avtEvenementDiff.push
        ({
          Evenement_Code: this.param_code,
          TypeDiffusion_Code: option.value,
          U_timestamp: null
        })
      }
    });
    // var evDif = this.dsEvenement.avtEvenementDiff.find(element => {return element.TypeDiffusion_Code == "3"});
    // if(evDif)
    // {
    //   if(dsEvenement.avtEvenementDiff.find(e =>{return e.TypeDiffusion_Code == this.positionEvennement}) == undefined)
    //   dsEvenement.avtEvenementDiff.push
    //   ({
    //     Evenement_Code: this.param_code,
    //     TypeDiffusion_Code: this.positionEvennement,
    //     U_timestamp: null
    //   })
    // }
    dsEvenement.avtEvenementDiff = dsEvenement.avtEvenementDiff.filter(diff =>{return this.generalService.isNotEmpty(diff.Evenement_Code)})
  }
  enregistrerEvenement(form : NgForm)
  {
    if(form.valid)
    {
      if(this.generalService.isNotEmpty(this.dsEvenement))
      {
        this.exist = false;
        var h1,h2,m1,m2;

        h1 = this.evenement.Evenement_HeureDebut.split(":")[0]
        m1 = this.evenement.Evenement_HeureDebut.split(":")[1]

        h2 = this.evenement.Evenement_HeureFin.split(":")[0]
        m2 = this.evenement.Evenement_HeureFin.split(":")[1];
        
        var d1 = new Date(this.dsEvenement.avtEvenement[0].Evenement_DateDebut)
        d1.setHours(h1,m1)
        var d2 = new Date(this.dsEvenement.avtEvenement[0].Evenement_DateFin)
        d2.setHours(h2,m2)
        this.dsEvenement.avtEvenement[0].Evenement_DateDebut = d1 //
        this.dsEvenement.avtEvenement[0].Evenement_DateFin = d2//this.dateService.setToFormatDateServerStr(this.dsEvenement.avtEvenement[0].Evenement_DateFin)
        this.genererListeDefEtListePublicToAdd(this.dsEvenement)
        
        this.evenement.Evenement_Information = this.editor.getHTML();
        this.generalService.enregisterTable(this.dsEvenement).subscribe(data =>
        {
          if(this.typeTrs == "1")
          {
            this.param_code = data.code;
            this.saveListeDefEtListePublic()
          }
          this.typeTrs = "2";
          this.deleteFinish = false;
          this.saveImageFinishe = false
          this.genererListeDefEtListePublicToDelete()
          this.saveImage(this.param_code);
          
        },
        ()=>
        {
          this.exist = true;
          this.generalService.dialogSuccess("Non eregistrer", false);
        })
      }
      else
      {
        this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
      }
    }
  }
  saveListeDefEtListePublic()
  {
    this.generalService.rechercheTable("ds/formdata?code=avtEvenement&val="+this.param_code).subscribe(dsEvenement => 
    {
      this.genererListeDefEtListePublicToAdd(dsEvenement)
      this.generalService.enregisterTable(dsEvenement).subscribe(data =>
      { 
        
      })
    })
  }
  saveImage(Evenement_Code : string)
  {
    if(this.generalService.isNotEmpty(this.imageName)  && this.generalService.isNotEmpty(this.imageSrc))
    {
      this.generalService.rechercheTable(this.generalService.urlFindDoc+this.param_code+","+"evenementImage"+","+"evenementImage").subscribe(image =>
      {
        if(image.length>0)
        {
          this.generalService.rechercheTable(this.generalService.urlFiles+"&val="+image[image.length-1].File_Id).subscribe(file =>
          {             
            file.Files[0].File_Text = this.imageName;
            file.Files[0].File_Content = this.imageSrc;
            file.Files[0].File_Autre = this.imageType;
            this.generalService.enregisterTable(file).subscribe(data =>
            {
              this.saveImageFinishe = true;
              this.generalService.dialogSuccess("Image enregistrer", true);
              this.tryHideLoading();
            },
            ()=>
            {
              this.generalService.dialogSuccess("Image non eregistrer", false);
            })             
          })
        }
        else
          this.addFiles(this.generalService.initDoc,this.imageSrc,this.imageName,Evenement_Code,"evenementImage",null,"evenementImage","",this.imageType)
      }); 
    } 
    else
    {
      this.saveImageFinishe = true
      this.tryHideLoading();
    }
  }
  
  addFiles(initDoc,File_Content,File_Text,File_Key,File_Type,File_Parent,File_Groupe,File_Lien,File_Autre)
  {
    initDoc.files[0].File_Parent =File_Parent;
    initDoc.files[0].File_Content = File_Content;
    initDoc.files[0].File_Text = File_Text;
    initDoc.files[0].File_Key = File_Key;
    initDoc.files[0].File_Type = File_Type;
    initDoc.files[0].File_Groupe = File_Groupe;
    initDoc.files[0].File_Lien = File_Lien;
    initDoc.files[0].File_Autre = File_Autre;
    initDoc.files[0].File_Dll = "jstree-file";
    this.generalService.enregisterTable(initDoc).subscribe(data =>
    {
      this.generalService.dialogSuccess("Image enregistré",true);
      this.saveImageFinishe = true
      this.tryHideLoading();
    });    
  }
  tryHideLoading()
  {
    if(this.deleteFinish && this.saveImageFinishe)
    {
      this.exist = true;
      this.generalService.dialogSuccess("Enregistré", true);
    }
  }
  // duffiser un evennement
  diffuserEvenement()
  {    
    
  }
  selectAll2()
  {
    this.ev_Type_diffusion.selectAll();
    this.onSelectionTypesDiffusion();
  }
  deSelectAll2()
  {
    this.ev_Type_diffusion.deselectAll();
    this.onSelectionTypesDiffusion();
  }
  // showOrHidePositionEvennement()
  // {
  //   if(this.ev_Type_diffusion.selectedOptions.selected.find(option => {return option.value == "3"}))
  //     this.showPositionEvennement = true;
  //   else
  //     this.showPositionEvennement = false;
  // }
  // declanced after Selection Types Diffusion Change
  onSelectionTypesDiffusion()
  {
    // this.showOrHidePositionEvennement();
  }
  selectAll()
  {
    this.ev_Type_public.selectAll();
  }
  deSelectAll()
  {
    this.ev_Type_public.deselectAll();
  }
  // declanced after Selection Types Public Change
  onSelectionTypesPublic()
  {

  }
   
  init()
  {
    if(this.typeTrs == "3")
    this.disabled = true;
    // Angular Editor Supprimer
    // this.editorConfig.editable = !this.disabled
    // Angular Editor Supprimer
    // this.editorConfig.height = "100px";
    this.getDsEvennement(this.param_code);
    this.getImage()
  }

  // get from server ds evennement
  getDsEvennement(Evenement_Code)
  {
    this.exist = false;
    var url = "ds/formdata?code=avtEvenement";
    if(this.typeTrs != "1")
    url += "&val=" + Evenement_Code
    this.generalService.rechercheTable(url).subscribe(data => 
    {
      this.dsEvenement = data;
      this.evenement = this.dsEvenement.avtEvenement[0];
      this.editor.setHTML(this.evenement.Evenement_Information)
      if(this.typeTrs != "1")
      {
        this.evenement.Evenement_DateDebut = new Date(this.evenement.Evenement_DateDebut);
        this.evenement.Evenement_DateFin = new Date(this.evenement.Evenement_DateFin);
        this.evenement.Evenement_HeureDebut = this.dateService.setFormaTime(this.evenement.Evenement_HeureDebut)
        this.evenement.Evenement_HeureFin = this.dateService.setFormaTime(this.evenement.Evenement_HeureFin)        
      }
      this.getListeMenu();
    })
  }
  // se declenche on saisissant time evenement
  timeChange(event) 
  {
    if(this.generalService.isNotEmpty(event.target.value))
    {
      this.filterdTime = this.time.filter((val) => 
      {
        return val.indexOf(event.target.value) >= 0;
      });
      if (this.filterdTime.length == 0) 
        event.target.value = event.target.value.substr(0, (event.target.value.length - 1));
    }
    else
      this.filterdTime = this.time.slice();
  }
  //se declenche apre que l'input name="Evenement_HeureDebut" ou l'input name="Evenement_HeureFin" perd le focus
  HeureEvenementBlur(event, champ)
  {
    this.filterdTime = this.time.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if(this.generalService.isNotEmpty(event.target.value) && this.filterdTime.length > 0 &&  this.filterdTime.find(time =>{return time == event.target.value}) == undefined)
    {
      event.target.value = this.filterdTime[0];
    }
    eval("this.evenement."+champ + " = '" + event.target.value + "'");
  }
  // lire de puis le serveur les parametre de temps
  getParamHeur()
  {
    this.generalService.rechercheTable(this.generalService.urlListeParamHeure).subscribe(data => 
    {
      this.paramHeure = data[0];
      this.time = this.dateService.generateListeTime(this.paramHeure.avtHeureAM_Deb,this.paramHeure.avtHeurePM_Fin,this.paramHeure.avtHeure_Ecart)
    })
  }
  getClass()
  {
    if(this.generalService.ajouterScroll)
    return " scroll-x "
    else
    return ""
  }
  readParamUrl()
  {    
    this.route.params.subscribe(params => 
    {      
      this.param_code = params['param_code'];
      this.typeTrs = params['typeTrs'];
      if(!this.generalService.isNotEmpty(this.param_code))
        this.param_code = this.generalService.param_code;
      if(!this.generalService.isNotEmpty(this.typeTrs))
        this.typeTrs = this.generalService.typeTrs;
      this.init()
    });
  }
}

